import { Component, OnInit } from '@angular/core';
import {ProjectsService} from '../../_services/projects.service';
import {GlobalService} from '../../_services/global.service';
import {ScrollEvent} from 'ngx-scroll-event';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayout implements OnInit {
  public backtoTop = false;
  public isEndPage = false;
  public handleScroll(event: ScrollEvent) {
    this.isEndPage = event.isReachingBottom;
    // console.log(window.scrollY);
    this.backtoTop = window.scrollY > 50;
    // if (window.scrollY > 50) {
    //   this.backtoTop = true;
    // } else {
    //   this.backtoTop = false;
    // }
  }

  constructor(private projectsService: ProjectsService, private globalService: GlobalService) {
    // console.log(localStorage.getItem('currentSmmData'));
    if (localStorage.getItem('currentSmmData') !== null) {
      this.projectsService.index().subscribe(res => {
        // console.log(res);
        this.globalService.setProjects(res.data.projects);
      });
    }
  }
  ngOnInit(): void {}
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/containers/full-layout/full-layout.component.ts